import axios, {AxiosResponse} from 'axios'
import { ReleaseNote } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const RELEASE_NOTES_URL = `${API_URL}/api/release-notes`

export function getReleaseNote(id: string): Promise<ReleaseNote> {
  return axios
    .get(`${RELEASE_NOTES_URL}/${id}`)
    .then((response: AxiosResponse<ReleaseNote>) => response.data)
}